import * as SearchlightActionCreators from 'a/actions/searchlightActionCreators';
import * as SearchlightActions from 'a/actions/searchlightActions';
import GameIds from 'a/hub/data/GameIds';
import { GRADES } from 'a/hub/data/constants';
import { SEARCHLIGHT_EVENT_TYPE } from 'root/lib/SearchlightDispatcher';
import { getCurrentYear } from 'root/lib/DatetimeManager';
import { METRIC_TYPE, APT_TYPES, ASSESSMENT_TYPES } from '../data/constants';

export const reportLoadPlacementTool = (gameId, data, dispatch) => {
  dispatch(SearchlightActions.reportLoadGame(gameId, data));
};

export const reportMeasureComplete = (measureId, value, data, dispatch) => {
  dispatch(SearchlightActionCreators.dispatchEventObj({
    // round session ID is cleared by ROUND_COMPLETE but this event fires after,
    // this bool will make sure the round session ID of the just finished round is used
    isUsePreviousRoundSessionId: true,
    metric: {
      type: METRIC_TYPE.TIME,
      id: 'amplify.AQUA.App.timeSpentInMeasure',
      value: value || 0,
    },
    application: {
      eventType: SEARCHLIGHT_EVENT_TYPE.MEASURE_COMPLETE,
      gameId: measureId,
      details: {
        measureId,
        ...data,
      },
    },
  }));
};

export const reportExitPlacementTool = (gameId, metric, placement) => (SearchlightActionCreators.dispatchEventObj({
  metric: {
    type: METRIC_TYPE.TIME,
    id: 'amplify.AQUA.App.timeSpentInIPT',
    value: metric,
  },
  application: {
    eventType: SEARCHLIGHT_EVENT_TYPE.EXIT_IPT,
    gameId,
    details: {
      total_score: placement,
    },
  },
}));

export const reportAssessmentEvent = (
  eventType,
  assessmentTypes,
  timeOfYear,
  grade,
  dispatch,
  isValidTroResult = true,
) => {
  const currentYear = getCurrentYear();
  const [assessmentType] = Object.keys(assessmentTypes).filter(type => assessmentTypes[type]);
  const secondMeasure = (
    assessmentType === ASSESSMENT_TYPES.PLACEMENT_APT
    || (assessmentType === ASSESSMENT_TYPES.PLACEMENT_ARBA && !isValidTroResult)
  ) ? GameIds.MIND_THE_GAP
    : GameIds.TRO;

  let measures = [GRADES.KINDERGARTEN, GRADES.PRE_KINDERGARTEN].includes(grade)
    ? [GameIds.REAL_WORD_READING]
    : [GameIds.REAL_WORD_READING, secondMeasure];

  if (assessmentType === ASSESSMENT_TYPES.BENCHMARK_MODE) {
    measures = [GameIds.TRO];
  }

  dispatch(SearchlightActionCreators.dispatchEventObj({
    application: {
      eventType,
      gameId: GameIds.ARBA,
      details: {
        measures,
        timeOfYear,
        schoolYearEnd: timeOfYear === APT_TYPES.BOY ? currentYear + 1 : currentYear,
      },
    },
  }));
};

export default {
  reportMeasureComplete,
};
